import React, { useState, useEffect } from "react";
import { CopyTwoTone, ArrowUpOutlined } from "@ant-design/icons";
import axios from "axios";
import { Card, Col, Row } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useTranslation } from "react-i18next";

const ChatComponent = () => {
  const [streamedMessages, setStreamedMessages] = useState([]);
  const [customCode, setCustomCode] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (messages.length > streamedMessages.length) {
      const newMessage = messages[messages.length - 1];
      let index = 0;
      let streamedText = "";

      const interval = setInterval(() => {
        if (index < newMessage.content.length) {
          streamedText += newMessage.content[index];
          setStreamedMessages((prev) => [
            ...prev.slice(0, messages.length - 1),
            { ...newMessage, content: streamedText },
          ]);
          index++;
        } else {
          clearInterval(interval);
        }
      }, 20);

      return () => clearInterval(interval);
    }
  }, [messages]);

  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopy = (content, index) => {
    navigator.clipboard.writeText(content);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 1000);
  };

  const onCustomChange = async () => {
    if (!customCode.trim()) return;

    const userMessage = { role: "user", content: customCode };
    setMessages((prev) => [...prev, userMessage]);

    setCustomCode(""); // Clear input after sending

    const systemMessage =
      "You are a programmer that provides only the correct code output based on the user's request. Do not provide explanations or markdown formatting.";

    setLoading(true); // Start loading before the response is generated

    try {
      const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        {
          model: "gpt-4",
          messages: [{ role: "system", content: systemMessage }, userMessage],
        },
        {
          headers: {
            Authorization: `Bearer sk-svcacct-NSZ0s5JiafyDQPeG9Pdk_caZTgMNqPUjiBdMMbSMDYtMQvXT0b3lJMlflAP0DIGR-F1T3BlbkFJiODfF0-a78sBQxSq78A7YAwrsI8NILJ253YWn7BjFAML7cWgGp-oUbyoPrbOqeW0f-QA`,
            "Content-Type": "application/json",
          },
        }
      );

      const botMessage = { role: "assistant", content: response.data.choices[0].message.content };

      setMessages((prev) => [...prev, botMessage]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading once response is received
    }
  };

  return (
    <Card className="mt-4" align="left">
      <Row justify="space-between" align="middle" gutter={[8, 8]} className="my-2">
        <Col>
          <h4>{t("impaqx.adminApp.aiSuggession")}</h4>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className="chat-container bg-gray-50 h-screen p-4 overflow-y-auto">
            {streamedMessages.map((msg, index) => (
              <div key={index} className={`flex my-2 ${msg.role === "user" ? "justify-end ml-auto w-75" : "justify-start"}`}>
                <div
                  style={{
                    backgroundColor: msg.role === "user" ? "#dddddd8c" : "#d0d0d029",
                    border: msg.role === "user" ? "2px solid blue" : "2px solid red",
                  }}
                  className={`${
                    msg.role === "user" ? "max-w-xs" : "max-w-md"
                  } p-4 rounded border overflow-auto whitespace-pre-wrap break-words border-gray-400 ${
                    msg.role === "user" ? "text-right" : "text-left"
                  }`}
                >
                  {msg.role !== "user" && (
                    <div style={{ textAlign: "end", marginBottom: "15px" }}>
                      <a onClick={() => handleCopy(msg.content, index)}>
                        <CopyTwoTone /> {copiedIndex === index ? "Copied!" : "Copy"}
                      </a>
                    </div>
                  )}
                  {msg.role === "assistant" && loading && index === messages.length - 1 ? (
                    <img src="https://impaqxcloudstorage.blob.core.windows.net/extremeb2b/appLogo/Circles-menu-3.gif" alt="Loading..." width="50" height="50" />
                    ) : (
                    <pre>{msg?.content?.replace(/^```[a-z]*\n|```$/g, "")}</pre>
                  )}
                </div>
              </div>
            ))}
            {loading && (
              <div className="flex justify-start my-2">
                    <img src="https://impaqxcloudstorage.blob.core.windows.net/extremeb2b/appLogo/Circles-menu-3.gif" alt="Loading..." width="50" height="50" />
              </div>
            )}
          </div>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className="p-4">
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <TextArea
                placeholder="Search here..."
                className="w-full p-4 border rounded h-16"
                value={customCode}
                onChange={(e) => setCustomCode(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    onCustomChange();
                  }
                }}
                style={{ paddingRight: "2.5rem" }}
              />
              <ArrowUpOutlined
                onClick={onCustomChange}
                style={{
                  position: "absolute",
                  right: "0.75rem",
                  cursor: "pointer",
                  color: "#1890ff",
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default ChatComponent;
